import ArrowClockwise from './src/arrow-clockwise-combined';
export default ArrowClockwise;